export default {"src":"/encomendas-static/_next/static/media/step-box.b4945d60.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};